import { setActiveTrace } from '../../../experience-trace-id-context';
import { withProfiling } from '../../../self-measurements';
import { generateSpanId } from '../generate-span-id';
export var setInteractionActiveTrace = withProfiling(function setInteractionActiveTrace(newId) {
  setActiveTrace(newId.replace(/-/g, ''), generateSpanId(), 'transition');
});